import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/integrations/page.tsx")